/**
 * @generated SignedSource<<1d0457520107accd0b712e336a38545f>>
 * @relayHash 84329df47f1d11ef5ea22b051cd3cb10
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID bf42e7ddc009675a1a3a9d923a4bd3521ec33bd4d30cc6125170cdf92f31cb44

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type SettingsMenuItemInput = {
  menuId: string;
  visible: boolean;
};
export type SettingsDisplayPropertyInput = {
  key: string;
  value: string;
};
export type useNetworkSideNavUserDataMutation$variables = {
  entityAri: string;
  ownerAri: string;
  properties?: ReadonlyArray<SettingsDisplayPropertyInput | null | undefined> | null | undefined;
  sidebar?: ReadonlyArray<SettingsMenuItemInput | null | undefined> | null | undefined;
};
export type useNetworkSideNavUserDataMutation$data = {
  readonly settings_updateNavigationCustomisation: {
    readonly properties: {
      readonly nodes: ReadonlyArray<{
        readonly key: string | null | undefined;
        readonly value: string | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly sidebar: {
      readonly nodes: ReadonlyArray<{
        readonly menuId: string | null | undefined;
        readonly visible: boolean | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type useNetworkSideNavUserDataMutation = {
  response: useNetworkSideNavUserDataMutation$data;
  variables: useNetworkSideNavUserDataMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "entityAri"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ownerAri"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "properties"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sidebar"
},
v4 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "entityAri",
        "variableName": "entityAri"
      },
      {
        "kind": "Variable",
        "name": "ownerAri",
        "variableName": "ownerAri"
      },
      {
        "kind": "Variable",
        "name": "properties",
        "variableName": "properties"
      },
      {
        "kind": "Variable",
        "name": "sidebar",
        "variableName": "sidebar"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v5 = {
  "concreteType": "SettingsMenuItemConnection",
  "kind": "LinkedField",
  "name": "sidebar",
  "plural": false,
  "selections": [
    {
      "concreteType": "SettingsMenuItem",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "menuId"
        },
        {
          "kind": "ScalarField",
          "name": "visible"
        }
      ]
    }
  ]
},
v6 = {
  "concreteType": "SettingsDisplayPropertyConnection",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": [
    {
      "concreteType": "SettingsDisplayProperty",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "key"
        },
        {
          "kind": "ScalarField",
          "name": "value"
        }
      ]
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useNetworkSideNavUserDataMutation",
    "selections": [
      {
        "args": (v4/*: any*/),
        "concreteType": "SettingsNavigationCustomisation",
        "kind": "LinkedField",
        "name": "settings_updateNavigationCustomisation",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/)
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "useNetworkSideNavUserDataMutation",
    "selections": [
      {
        "args": (v4/*: any*/),
        "concreteType": "SettingsNavigationCustomisation",
        "kind": "LinkedField",
        "name": "settings_updateNavigationCustomisation",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "kind": "ScalarField",
            "name": "id"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "bf42e7ddc009675a1a3a9d923a4bd3521ec33bd4d30cc6125170cdf92f31cb44",
    "metadata": {},
    "name": "useNetworkSideNavUserDataMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "166e48d711d0b7e49b146e7ff8ab2745";

export default node;
